//import LocalizedStrings from 'react-localization';
import { getStrings } from '../../../../Common/Localization/commonStrings';
// -------------------

const localizedStrings = {
  addressBook: {
    strings: {
      en: {
        voicemail1: 'Voice Message',
        voicemail2: 'Voice Message',
        phone: 'Text/SMS',
        voicemail3: 'Voice Message',
        email: 'Email',
        createContactheading: 'Create New Contact',
        createFirstNamePlaceHolder: 'First Name',
        createLastNamePlaceholder: 'Last Name',
        voicemail1Placeholder: 'Phone / Voicemail 1',
        phoneErrorMsg: 'Please enter valid number.',
        emailErrorMessage: 'Please use a valid email address.',
        mobPlaceholder: 'Mobile Phone / Text',
        voicemail3Placeholder: 'Mobile Phone / Voicemail 3',
        voicemail2Placeholder: 'Phone / Voicemail 2',
        addressBookHeading: 'Address Book',
        addressBookMsg: 'All contacts in the Address Book can be seen and assigned by all authorized users of this account.',
        cppAssignedContact: 'CPP Assigned Accounts:',
        roAssignedContact: 'RO Assigned Accounts:',
        delete: 'Delete',
        edit: 'Edit',
        noContactsMessage: 'No contacts have been created yet.',
        deleteContactHeading: 'Delete Contact?',
        deleteText: 'Are you sure you want to delete:',
        deleteMessage: 'This contact will no longer be available for notifications on any service accounts, and will be permanently deleted from the Address Book. This contact is currently assigned to:',
        serviceAccounts: 'service accounts',
        editContactHeading: 'Edit Contact',
        editKey: 'edit',
        addKey: 'add',
        deleteKey: 'delete',
        cancelAddContact: 'cancelAddContact',
        deleteContactConfirm: 'Yes, delete contact',
        cancelDialog: 'Cancel'
      },
      es: {
      }
    },
    common: []
  },
  dialogBox: {
    strings: {
      en: {
        bulkNote:'Note:Bulk updates may not be reflected immediately.',
        assignContactHeader: 'Assign New Contact',
        currentlyAssigned: 'Assigned',
        noContactsAssign: 'No contacts available to assign',
        select: 'Select',
        createNewContact: 'Create New Contact',
        remove: 'remove',
        contactMethodOne: 'Contact Method 1',
        contactMethodTwo: 'Contact Method 2 (Optional)',
        removeText: 'This contact will be removed from the assignment list for the following service account.',
        removeMessage: 'The selected contact(s) will be removed from the assignment list for the following service accounts, but will remain in the Address Book.',
        removeMessageSingle: 'This contact will be removed from the assignment list for the following account, but will remain in the Address Book.',
        removeConfirmationText: 'Are you sure you want to remove this contact?',
        removeConfirmationTextCom: 'Are you sure you want to remove the selected contact(s)?',
        removeContactLabel: 'Remove Contact?',
        removeContactMultiLabel: 'Remove Contact(s)?',
        removeContactsLabel: 'Remove Contact(s)',
        successEditText: 'Your changes have been saved.',
        successeditBtnText: 'Return to Set Notifications',
        ok: 'OK', okButton: 'okButton',
        successAddText: 'Your contact has been created and added to the Address Book. It is now available to be assigned to any service account.',
        successAddBtnText: 'Return to Address Book',
        close: 'Close',
        successDeleteText: 'Your phone number has been deleted.',
        successRemoveText: 'Your selected contact(s) has been removed from the assignment list.They are still accessible in the Address Book.',
        successSetNotifText: 'Your selection(s) have been updated.',
        successResRemoveText: 'Your selected contact(s) have been removed from the assignment list.',
        successModifyContactText: 'Your selection(s) have been successfully updated.',
        success: 'Success!',
        editKey: 'edit',
        addKey: 'add',
        deleteKey: 'deleteContact',
        removeKey: 'remove',
        setNotifKey: 'setnotification',
        residentialRemoveKey: 'residentialRemove',
        modifyContactKey: 'modifyContact',addContactKey: 'addContact',saveContactKey: 'saveContact',
        commercialkey: 'COM',
        setNotifLabel: 'Set Notifications',
        editContactLabel: 'Edit Contact',
        none: 'None',
        invalid: 'invalid',
        name: 'name',
        primaryContact: 'primaryContact',
        secondaryContact: 'secondaryContact',
        textMsg: 'Text Message',
        voiceMsg: 'Voice Message',
        setNotifHeading: 'Set Notifications',
        primaryContactMethod: 'Primary Contact Method',
        resModifyNamePlaceholder: 'First and Last Name',
        isAnyCheckBoxCheckedErrorMsg: 'Please make a selection.',
        seconadryContactLabel: 'Secondary Contact Method (optional)',
        email: 'Email',
        addAnotherEmail: '   Add email',
        addAnotherPhone: '   Add phone',
        inputAddButtonText: 'Add',
        inputEditButtonText:'Save',
        deletePhoneNumberSubHeading: 'You are deleting the phone number:',
        /***********************
        Change type : CSRP_PASS2_CPP defect #10297 fix
        Changed by: Sai Aman Pothuganti
        Date : 05-18-2020
        ************************/
        deletePhoneNumberInfo: 'By deleting this phone number, you will no longer receive any alerts associated with this number.',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
        btnClose: 'Close',
        NONE: 'NONE',
        emailSameValueErrorMsg:"Same email devices cannot be selected.",
        voiceSameValueErrorMsg:"Phone number already exists",
        textSameValueErrorMsg:"Phone number already exists",
        emailSamePreferenceSavedErrorMsg:"It looks like the same email device already exists.Please call us at 1-800-655-4555 and we'll help you submit your request.",
        voiceSamePreferenceSavedErrorMsg:"It looks like the same phone device already exists.Please call us at 1-800-655-4555 and we'll help you submit your request.",
        textSamePreferenceSavedErrorMsg:"It looks like the same phone device already exists.Please call us at 1-800-655-4555 and we'll help you submit your request.",
        confirmDeleteEmailHeading: 'Confirmation',
        confirmPhoneNumberDeleteSubHeading: 'Your phone number has been deleted:',
        /***********************
        Change type : CSRP_PASS2_CPP defect #10297 fix
        Changed by: Sai Aman Pothuganti
        Date : 05-18-2020
        ************************/
        confirmPhoneNumberDeleteInfo: 'You will no longer receive any alerts associated with this number.',
        limitText:'(limit 3 contacts)',
      },
      es: {
      }
    },
    common: []
  },
  contactAssignment: {
    strings: {
      en: {
        notificationMethod: 'Notification Method: ',
        removeLink: 'Remove',
        modifyLink: 'Modify',
        addressBook: 'Address Book',
        assignNewBtn: 'Assign New Contact',
        selectContactText: 'Select the contact and method for receiving CPP notifications.',
        contactListHeadingPart1: 'Service Account -',
        contactListHeadingPart2: 'Assigned Contacts',
        noContactAssigned: 'no contacts have been assigned yet',
        cancelEditContact: 'cancelEditContact',
        cancelAddContact: 'cancelAddContact',
        cancelAddressBook: 'cancelAddressBook',
        cancelDeleteContact: 'cancelDeleteContact',
        addressBookKey: 'addressBook',
        setNotificationDialog: 'setNotificationDialog',
        removeContactDialog: 'removeContactDialog',
        assignNewContactDialog: 'assignNewContactDialog',
        assignContactKey: 'assignContact',
        fixedClass: 'fixed',
        hiddenClass: 'hidden',
        serviceAccount: 'Service Account',
        assignedContact: 'Assigned Contact',
        cppEvent: 'CPP Events',
        cppHeader: 'CPP notifications are sent for CPP Event and Non-Event periods.',
        roHeader: 'Notifications are sent before a Rotating Outage is called.',
        cppHeaderDesc: 'Select the person who will receive CPP notifications and how they will receive them.',
        roHeaderDesc: 'Select the person who will receive RO notifications and how they will receive them.',
        notifMethod: 'Notification Method:',
        remove: 'Remove',
        noContactsMsg: 'No contacts have been assigned yet',
        assignedContactHeader:'Assigned Contacts',
        componentName:'contactAssignmentComponent'
      },
      es: {
      }
    },
    common: []
  },
  CPPSpecific: {
    strings: {
      en: {
        componentType: 'CPP Events',
        mainHeading: 'Critical Peak Pricing (CPP) Notification Preferences',
        //eligibleMsg: 'You are eligible for CPP and required to receive notifications for CPP Event periods. If your usage is not reduced within CPP parameters, your bill may be impacted.',
        eligibleMsg: 'You are eligible for CPP. CPP provides four months of summer season bill credits in exchange for higher prices during 12 annual CPP events. When called, CPP events are from 4 p.m. – 9 p.m. on non-holiday weekdays, usually occurring on the hottest summer days. By reducing your electricity use during CPP events, you can minimize the impacts of these higher prices.',
        eligibleMsgSubText: 'Use courtesy alerts to help plan for CPP events. We will notify you the day before an event via phone, email, or text.',
        eligibleMsgSubTextTwo: 'Below, select the Contracts to which you would like to add notifications. We recommend having at least one contact per Contract to ensure you stay current with the most important updates.',
        ineligibleText: 'You are not eligible for Critical Peak Pricing. Only customers who are enrolled in Critical Peak Pricing will receive notifications when a CPP Event is called.',
        // eligibleText: 'You are enrolled in the CPP program and would benefit from receiving notifications for CPP Event periods. The event notifications will alert you when to reduce your usage. If you are unaware of CPP event hours and don’t take action, your bill may be impacted. Select the service accounts to which you would like to add notifications. We recommend having at least one contact per service account to ensure someone is notified of important program updates.',
        toolTipMsg: 'Critical Peak Pricing is an event-based pricing option which provides bill credits during summer CPP Non-Event Credit Periods and incremental bill charges for load served by SCE during CPP Event Charge Periods. No CPP credits will be provided for exported generation, i.e., energy produced and exported by the customer’s generating facility during CPP Non-Event Credit Periods.',
        contactAssignmentMsg: 'CPP notifications are sent for CPP Event and Non-Event periods. Select the person who will receive CPP notifications and how they will receive them.',
        addressBookModify: 'addressBookModify',
        success: 'success',
        contactAssignmentComponent: 'ContactAssignmentComponent',
        customerAccountComponent: 'CustomerAccountComponent',
        addressBook: 'addressBook',
        assignContactKey: 'assignContact',
        modifyContactKey: 'modifyContact',
        addContactKey: 'addContact',saveContactKey: 'saveContact',
        deleteContactKey: 'deleteContact',
        residentialRemove: 'residentialRemove',
        globalErrorMessage: 'We\'re having some technical issues at the moment. While we work to fix it, give us a call at 1-800-284-2365, or try again later.',
        cppEvent: 'CPP',
        /************************
        Change type : Error message Implementation in CPP v1.0
        Changed by: Sai Aman Pothuganti
        Date : 05-06-2020
        ************************/ 
        default: "DEFAULT",

      },
      es: {
      }
    },
    common: []
  },
  ROSpecific: {
    strings: {
      en: {
        componentType: 'Outage Notif',
        eligibleMsg: 'Select the service accounts to which you would like to add notifications. We recommend having at least one contact per service account to ensure you stay current with the most important updates.',
        mainHeading: 'Rotating Outage (RO) Notification Preferences',
        toolTipMsg: 'Sometimes called a “rolling blackout”, a Rotating Outage is an extremely rare, controlled power outage that we enact as a last resort when there is a statewide emergency. For one hour at a time, we shut down power by geographical groups-known as Rotating Outage Groups or Rotating Outage Group Blocks-to help ease the demand on the electrical grid. Rotating Outages help prevent larger and longer power outages.',
        contactAssignmentMsg: 'Notifications are sent before a Rotating Outage is called. Select the person who will receive CPP notifications and how they will receive them.',
        addressBookModify: 'addressBookModify',
        customerAccountComponent: 'CustomerAccountComponent',
        contactAssignmentComponent: 'ContactAssignmentComponent',
        success: 'success',
        addressBook: 'addressBook',
        assignContactKey: 'assignContact',
        modifyContact: 'modifyContact',
        globalErrorMessage: 'We\'re having some technical issues at the moment. While we work to fix it, give us a call at 1-800-284-2365, or try again later.',
      },
      es: {
      }
    },
    common: []
  },
  customerAccountComponent: {
    strings: {
      en: {
        selectAllLabel: 'Select All',
        assignContact: 'Assign Contact',
        removeContact: 'Remove Contact',
        showAll: 'Show All',
        noContactMsg: 'No Contact Assigned',
        searchDesktopPlaceholder: 'Search service account number, name and address',
        searchMobilePlaceholder: 'Search',
        displayMsg: 'Displaying Customer Account :',
        addressBook: 'Address Book',
        serviceAccounts: 'Service Accounts',
        emptySearchTextErrorMessage: 'Please enter an Account Number or Address',
        invalidSearchTextErrorMessage: 'Please enter a Valid Account Number or Address',
        noServiceAccountMessage: 'No Service Account available to show for the selected Customer Account',
        scroll: 'scroll',
        cancelEditContact: 'cancelEditContact',
        cancelAddContact: 'cancelAddContact',
        cancelAddressBook: 'cancelAddressBook',
        cancelDeleteContact: 'cancelDeleteContact',
        addressBookKey: 'addressBook',
        commercial: 'COMMERCIAL',
        residential: 'RESIDENTIAL',
        notidentified: 'NOT IDENTIFIED',
        nonassigned: 'NON ASSIGNED',
        assignContactKey: 'assignContact',
        assign: 'assign',
        removeContactDialog: 'removeContactDialog',
        removeContactResidentialDialog: 'removeContactResidentialDialog',
        assignNewContactDialog: 'assignNewContactDialog',
        removeContactSelectDialog: 'removeContactSelectDialog',
        setNotificationDialog: 'setNotificationDialog',
        setResidentialNotificationDialog: 'setResidentialNotificationDialog',
        previousButtonClick: 'previousButtonClick',
        showLess: 'showLess',
        sceFixedHeader: 'sceFixedHeader',
        modify: 'modify',
        remove: 'remove',
        fixedClass: 'fixed',
        hiddenClass: 'hidden',
        customerAccountList: 'customer account list',
        onChange: 'onChange',
        onClear: 'onClear',
        onSubmit: 'onSubmit',
        onKeyPress: 'onKeyPress',
        enter: 'Enter',
        assignContacts: 'Assigned Contacts:',
        assignedContactLabel: 'Assigned Contact',
        assignedContact: 'Assigned Contact:',
        viewEditLink: 'View / Edit',
        selectAll: 'Select All',
        residentialAssignText: 'Some of the selected accounts have previously assigned contacts. Please confirm whether you want to overwrite the existing contacts for following accounts or add contacts to only unassigned accounts.',
        residentialAssignConf: 'Are you sure you want to proceed?',
        serviceAccountsHeaderText: 'Service Account(s)',
        componentName:'customerAccountComponent',
        deleteContactKey: 'deleteContact',
      },
      es: {
      }
    },
    common: []
  },
  CppBulkNotification: {
    strings: {
      en: {
        notEnrolled: 'Not enrolled',
        alreadyEnrolled: 'Already enrolled',
        filterBy:'Filter By:',
      },
      es: {
      }
    },
    common: []
  },
};

export const getLocalizedStrings = (componentName) => {
  // app.logger.getLogger().info('Comp Name' + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
  //return new LocalizedStrings(strings);
};
